import React from 'react';
import { BsTwitter, BsInstagram, BsLinkedin, BsGithub } from 'react-icons/bs';
//import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <div>
        <a
          href='https://www.linkedin.com/in/nazranzaki/'
          target='_blank'
          rel='noopener noreferrer'
        >
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a
          href='https://github.com/MNazran'
          target='_blank'
          rel='noopener noreferrer'
        >
          <BsGithub />
        </a>
      </div>
      {/* <div>
        <BsInstagram />
      </div> */}
    </div>
  );
};

export default SocialMedia;
